exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invoice-create-page .invoice-foot .invoice-total {\n  min-width: 390px;\n}\n@media (max-width: 480px) {\n.invoice-create-page .invoice-foot .invoice-total {\n    min-width: 384px;\n}\n}", ""]);

// exports
